import CheckBoxPicker from './CheckBoxPicker'

export default CheckBoxPicker
